import { Injectable } from '@angular/core';
import { Http, RequestOptions, RequestOptionsArgs } from '@angular/http';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { tap, catchError, windowCount } from 'rxjs/operators';

import { BciLoaderService } from '@bci-web-core/core';
import { AlertService, Constants, CLIENT_ID$, CLIENT_SECRET$ } from 'src/app/shared/index';

@Injectable()
export class DataService {
    private loadingBar: any;
    httpOptions: any;
	httpHeader: HttpHeaders;						
    constructor(private _http: HttpClient,
        private loader: BciLoaderService,
        private alertService: AlertService) {
		this.httpHeader = new HttpHeaders({
            // 'Content-Type': 'application/json;charset=UTF-8',
            // 'Access-Control-Allow-Origin': '*',
            // 'Accept': 'application/json, text/plain, */*',
            // 'Access-Control-Allow-Methods': 'GET, POST, DELETE, PUT, OPTIONS'
        });	
        this.httpOptions = {
            headers: this.httpHeader 
        };
    }
    
    getImageContent(url: string): Observable<Blob> {
        return this._http.get(url, { responseType: 'blob' }).pipe(tap(
            res => {
                this.loader.hideProgressBar(this.loadingBar);
                this.loadingBar = null;
                return res;
            })
            , catchError(err => {
                this.loader.hideProgressBar(this.loadingBar);
                this.loadingBar = null;
                this.alertService.message = err.error.message ? err.error.message : Constants.MESSAGE.GettingErrorMess;
                this.alertService.showError();
                return throwError(err);
            })
        );
    }

    getData(url: string, showProgessBar: boolean = true, responsePlainText: boolean = false) {
        if (this.loadingBar != null) {
            this.loader.hideProgressBar(this.loadingBar);
            this.loadingBar = null;
        }
        if (showProgessBar === true) {
            this.loadingBar = this.loader.showProgressBar();
        }
        let newHttpOptions = this.httpOptions;
        if (responsePlainText) {
            newHttpOptions = {
                headers: this.httpHeader,
                responseType: 'text'
            }
        }					  
        return this._http.get(url, newHttpOptions).pipe(tap(
            res => {
                this.loader.hideProgressBar(this.loadingBar);
                this.loadingBar = null;
                return res;
            })
            , catchError(err => {
                this.loader.hideProgressBar(this.loadingBar);
                this.loadingBar = null;
               // this.alertService.message = err.error.message ? err.error.message : Constants.MESSAGE.GettingErrorMess;
                this.alertService.message="Atleast one or more widgets failed to load complete data, Please try refreshing the page again.";
                this.alertService.showError();
                return throwError(err);
            })
        );
    }
    postData(url: string, data: any, showProgessBar: boolean = true) {
        if (this.loadingBar != null) {
            this.loader.hideProgressBar(this.loadingBar);
            this.loadingBar = null;
        }
        if (showProgessBar === true) {
            this.loadingBar = this.loader.showProgressBar();
        }
        return this._http.post(url, data, this.httpOptions).pipe(tap(
            res => {
                this.loader.hideProgressBar(this.loadingBar);
                this.loadingBar = null;
                return res;
            })
            , catchError(err => {
                this.loader.hideProgressBar(this.loadingBar);
                this.loadingBar = null;
                //this.alertService.message = err.error.message ? err.error.message : Constants.MESSAGE.PostingErrorMess;
                this.alertService.message="Atleast one or more widgets failed to load complete data, Please try refreshing the page again.";
                this.alertService.showError();
                return throwError(err);
                // return err;
            })
        );
    }
    saveData(url: string, data: any) {
        if (this.loadingBar != null) {
            this.loader.hideProgressBar(this.loadingBar);
            this.loadingBar = null;
        }

        this.loadingBar = this.loader.showProgressBar();

        return this._http.post(url, data).pipe(tap(
            res => {
                this.loader.hideProgressBar(this.loadingBar);
                this.loadingBar = null;
                return res;
            })
            , catchError(err => {
                this.loader.hideProgressBar(this.loadingBar);
                this.loadingBar = null;
                this.alertService.message = err.error.message ? err.error.message : Constants.MESSAGE.SavingErrorMess;
                this.alertService.showError();
                return throwError(err);
            })
        );
    }
    delete(url: string) {
        if (this.loadingBar != null) {
            this.loader.hideProgressBar(this.loadingBar);
            this.loadingBar = null;
        }
        this.loadingBar = this.loader.showProgressBar();

        return this._http.delete(url).pipe(tap(
            res => {
                this.loader.hideProgressBar(this.loadingBar);
                this.loadingBar = null;
                return res;
            })
            , catchError(err => {
                this.loader.hideProgressBar(this.loadingBar);
                this.loadingBar = null;
                this.alertService.message = err.error.message ? err.error.message : Constants.MESSAGE.DeletingErrorMess;
                this.alertService.showError();
                return throwError(err);
            })
        );
    }

    deleteWithBody(url: string, data: any) {
        if (this.loadingBar != null) {
            this.loader.hideProgressBar(this.loadingBar);
            this.loadingBar = null;
        }
        this.loadingBar = this.loader.showProgressBar();
        this.httpOptions.body = data;
        return this._http.delete(url, this.httpOptions).pipe(tap(
            res => {
                this.loader.hideProgressBar(this.loadingBar);
                this.loadingBar = null;
                return res;
            })
            , catchError(err => {
                this.loader.hideProgressBar(this.loadingBar);
                this.loadingBar = null;
                this.alertService.message = err.error.message ? err.error.message : Constants.MESSAGE.DeletingErrorMess;
                this.alertService.showError();
                return throwError(err);
            })
        );
    }

    showProgressBar(show: boolean) {
        if (show === true) {
            if (this.loadingBar != null) {
                this.loader.hideProgressBar(this.loadingBar);
                this.loadingBar = null;
            }
            this.loadingBar = this.loader.showProgressBar();
        } else {
            this.loader.hideProgressBar(this.loadingBar);
            this.loadingBar = null;
        }

    }

    downloadExcel(url: string, data: any): Observable<Object[]> {
        if (this.loadingBar != null) {
            this.loader.hideProgressBar(this.loadingBar);
            this.loadingBar = null;
        }
        this.loadingBar = this.loader.showProgressBar();
        const main = this;

        return Observable.create(observer => {

            const xhr = new XMLHttpRequest();

            xhr.open('POST', url);
            xhr.setRequestHeader('Content-type', 'application/json');
            xhr.responseType = 'blob';

            xhr.onreadystatechange = function () {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {

                        main.loader.hideProgressBar(main.loadingBar);
                        main.loadingBar = null;

                        const contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
                        const blob = new Blob([xhr.response], { type: contentType });
                        observer.next(blob);
                        observer.complete();
                    } else {
                        observer.error(xhr.response);
                    }
                }
            };
            xhr.send(JSON.stringify(data));

        });
    }
    uploadDocument(url: string, data: any) {
        if (this.loadingBar != null) {
            this.loader.hideProgressBar(this.loadingBar);
            this.loadingBar = null;
        }
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'multipart/form-data',
            })
        };
        this.loadingBar = this.loader.showProgressBar();
        return this._http.post(url, data).pipe(tap(
            res => {
                this.loader.hideProgressBar(this.loadingBar);
                this.loadingBar = null;
                return res;
            })
            , catchError(err => {
                this.loader.hideProgressBar(this.loadingBar);
                this.loadingBar = null;
                this.alertService.message = err.error.message ? err.error.message : Constants.MESSAGE.PostingErrorMess;
                this.alertService.showError();
                return throwError(err);
            })
        );
    }

    postLogin(url: string, username: string, password: string, showProgessBar: boolean = true) {
        if (this.loadingBar != null) {
            this.loader.hideProgressBar(this.loadingBar);
            this.loadingBar = null;
        }

        const headers = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                'Access-Control-Allow-Origin': '*',
                // 'Accept': 'application/json',
                // 'Access-Control-Allow-Methods': 'GET, POST, DELETE, PUT, OPTIONS'
            })
        };

        const httpParams = new HttpParams()
            .set('client_id', CLIENT_ID$)
            .set('client_secret', CLIENT_SECRET$)
            .set('grant_type', 'password')
            // .set('scope', 'if no scope just delete this line')
            .set('username', username)
            .set('password', password);
        // Make connection

        return this._http.post(url, httpParams.toString(), headers).pipe(tap(
            (res: any) => {
                this.loader.hideProgressBar(this.loadingBar);
                this.loadingBar = null;
                return res;
            })
            , catchError(err => {
                this.loader.hideProgressBar(this.loadingBar);
                this.loadingBar = null;
                this.alertService.message = err.error.message ? err.error.message : Constants.MESSAGE.PostingErrorMess;
                this.alertService.showError();
                return throwError(err);
            })
        );
    }

    refreshToken(url: string, refreshToken: string, showProgessBar: boolean = true) {
        if (this.loadingBar != null) {
            this.loader.hideProgressBar(this.loadingBar);
            this.loadingBar = null;
        }

        const headers = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                'Access-Control-Allow-Origin': '*',
                // 'Accept': 'application/json',
                // 'Access-Control-Allow-Methods': 'GET, POST, DELETE, PUT, OPTIONS'
            })
        };

        const httpParams = new HttpParams()
            .set('client_id', CLIENT_ID$)
            .set('client_secret', CLIENT_SECRET$)
            .set('grant_type', 'refresh_token')
            .set('refresh_token', refreshToken);

        // Make connection
        return this._http.post(url, httpParams.toString(), headers).pipe(tap(
            (res: any) => {
                this.loader.hideProgressBar(this.loadingBar);
                this.loadingBar = null;
                return res;
            })
            , catchError(err => {
                this.loader.hideProgressBar(this.loadingBar);
                this.loadingBar = null;
                this.alertService.message = err.error.message ? err.error.message : Constants.MESSAGE.PostingErrorMess;
                this.alertService.showError();
                return throwError(err);
            })
        );
    }

    getPDF(url: string, showProgessBar: boolean = true) {
        if (this.loadingBar != null) {
            this.loader.hideProgressBar(this.loadingBar);
            this.loadingBar = null;
        }
        if (showProgessBar === true) {
            this.loadingBar = this.loader.showProgressBar();
        }
        const httpOptions = {
            'responseType'  : 'arraybuffer' as 'json'
        };
        // Make connection
        // return this._http.get<any>(url, httpOptions);
        return this._http.get<any>(url, httpOptions).pipe(tap(
            (res: any) => {
                this.loader.hideProgressBar(this.loadingBar);
                this.loadingBar = null;
                return res;
            })
            , catchError(err => {
                this.loader.hideProgressBar(this.loadingBar);
                this.loadingBar = null;
                this.alertService.message = err.error.message ? err.error.message : Constants.MESSAGE.GettingErrorMess;
                this.alertService.showError();
                return throwError(err);
            })
        );
    }

}
